import React from "react";
import { signalStories } from "../mock";
import { TrendingUp, ArrowUpRight } from "lucide-react";

export default function SignalStories() {
  return (
    <section className="relative border-t border-slate-200/80 bg-[#faf8f3] py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="text-center">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">
            Customer Outcomes
          </p>
          <h2 className="mx-auto mt-3 max-w-3xl text-4xl font-medium tracking-tight text-[#1e1b4b] sm:text-5xl">
            Real teams. <span className="text-slate-400">Real results.</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[15px] text-slate-600">
            Six industries, six original case studies — measured outcomes from
            teams that traded guesswork for actionable buyer data.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {signalStories.map((s) => (
            <article
              key={s.headline}
              className="group relative flex flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white p-6 transition-all hover:-translate-y-1 hover:shadow-[0_24px_50px_-20px_rgba(30,27,75,0.18)]"
            >
              <div className="flex items-center justify-between">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-[#1e1b4b]/[0.06] px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-[#1e1b4b]">
                  {s.industry}
                </span>
                <ArrowUpRight className="h-4 w-4 text-slate-300 transition-all group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-[#d4af37]" />
              </div>

              <h3 className="mt-5 text-[17px] font-semibold leading-snug text-[#1e1b4b]">
                {s.headline}
              </h3>

              <div className="mt-6 flex items-end justify-between border-t border-slate-100 pt-5">
                <div>
                  <div className="flex items-baseline gap-2">
                    <TrendingUp className="h-4 w-4 text-[#d4af37]" />
                    <span className="text-3xl font-medium tracking-tight text-[#1e1b4b]">
                      {s.metric}
                    </span>
                  </div>
                  <p className="mt-1 text-[10.5px] font-medium uppercase tracking-wider text-slate-500">
                    {s.metricLabel}
                  </p>
                </div>
                <div className="text-right">
                  <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400">
                    Beacon Client
                  </p>
                  <p className="mt-1 text-sm font-semibold text-[#1e1b4b]">
                    {s.brand}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
